import { createRouter, useNavigate } from '@tanstack/react-router';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';
import { NotFound } from '@nesso/ui/blocks/not-found';

import { queryClient } from '@/app/providers/query-client';
import { Page } from '@/shared/ui/layout/page';
import { NavigationBar } from '@/shared/ui/navigation/navigation-bar';
import { TrialBanner } from '@/widgets/subscription/trial-banner';
import { UserDropdown } from '@/widgets/user/user-dropdown';

import { routeTree } from './route-tree.gen';

function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <Page>
            <NavigationBar
                dropdown={<UserDropdown />}
                banner={<TrialBanner />}
                mobileBanner={<TrialBanner variant="mobile" />}
            />
            <NotFound
                actionLabel="Return to Dashboard"
                onAction={() => navigate({ to: '/dashboard' })}
            />
        </Page>
    );
}

export const router = createRouter({
    routeTree,
    defaultPreload: 'intent',
    notFoundMode: 'root',
    defaultNotFoundComponent: NotFoundPage,
    defaultPendingComponent: LoadingPage,
    context: { queryClient },
});

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}
